/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const { state } = store('superniche-header', {
  actions: {
    toggleSearch: () => {
      state.isSearchOpen = !state.isSearchOpen;
    },
    toggleSideMenu: () => {
      state.isSideMenuOpen = !state.isSideMenuOpen;
    },
  },
  callbacks: {
    keyboardClose: (e) => {
      if (e.key === 'Escape') {
        state.isSearchOpen = false;
        state.isSideMenuOpen = false;
      }
    },
    handleSubMenus: (e) => {
      const { ref } = getElement();

      const parentListItems = ref.querySelectorAll(
        '.side-menu .menu-item-has-children'
      );

      parentListItems.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.target.classList.toggle('active');
        });
      });
    },
    isSearchOpen: () => {
      const { ref } = getElement();

      if (state.isSideMenuOpen) {
        state.isSearchOpen = false;
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'initial';
      }

      if (state.isSearchOpen) {
        ref.querySelector('.search-field').focus();
      } else {
        ref.querySelector('.search-field').blur();
      }
    },
  },
});
